import { FC, useEffect } from "react";
import "../CSS/CalendarDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import locationIcon from "../../../assets/images/location-icon.svg";
import appTextIcon from "../../../assets/images/header-text-icon.svg";
import whatsappIcon from "../../../assets/images/whatsapp-icon.svg";
import starIcon from "../../../assets/images/communicate-star-icon.svg";
import workspaceAppIcon from "../../../assets/images/workspace-detail-background.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ImageCarousel from "components/elements/ImageCarousel";
import {
  CALENDAR_RESERVATION_TYPE,
  MEMBER_BENEFITS_TYPE,
  MENU_ITEM,
} from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import {
  getMemberBenefitsRealLifeImages,
  getTermaAndConditionsText,
} from "utils/utils";
import { STORAGE_KEY, WEB_LINK } from "utils/strings";
import { useLogout } from "services/LogoutProvider";
import ROUTE_PATHS from "utils/routePaths";
import { trackDetailView } from "utils/analytics";
import ExpandableView from "components/elements/ExpandableView";

const CommunicateSpaceDetailScreen: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSelectedTabBar } = useTabBar();
  const { handleAppExit } = useLogout();

  useEffect(() => {
    trackDetailView("communicate_space", "COMMUNICATE_SPACE");
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleReserveClick = () => {
    const fromPath = (location.state as { from?: string } | null)?.from;
    if (
      fromPath === ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL ||
      fromPath === ROUTE_PATHS.WSM_MEMBERSHIP_PLAN_DETAIL
    ) {
      navigate(-2);
    } else {
      navigate(-1);
    }
    sessionStorage.setItem(
      STORAGE_KEY.CALENDAR_SELECTED_TAB,
      CALENDAR_RESERVATION_TYPE.MEETING_ROOMS,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
  };

  const openWorkspaceLocation = () => {
    handleAppExit(WEB_LINK.SABE_LOCATION);
  };

  const openWhatsappChannel = () => {
    handleAppExit(WEB_LINK.WHATSAPP_CHANNEL);
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar_detail-screen-container">
        <div className="calendar_detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <span>
            Communicate <span style={{ color: "#C2B58C" }}>Space</span>
          </span>
        </div>
        <div className="calendar_detail-app-icon-container">
          <img src={workspaceAppIcon} alt="location-logo" />
        </div>
        <div className="calendar_detail-date-location-container">
          <div className="detail-container">
            <div className="image">
              <img src={locationIcon} alt="location-logo" />
            </div>
            <div className="right-container">
              <div className="sub-container">
                <span>SabeHub, Mohali</span>
                <span className="sub-text">SCO-3, 2nd Floor, Sec-68</span>
              </div>
              <button onClick={openWorkspaceLocation}>Direction</button>
            </div>
          </div>
        </div>
        <div className="calendar_detail-container">
          <span>
            bout <span style={{ color: "#C2B58C" }}>Communicate Space</span>
          </span>
          <div className="divider"></div>
          <div className="communicate_space_container ">
            <span>
              Where conversations{" "}
              <span style={{ color: "#C2B58C" }}>create clarity.</span>
            </span>
            <span className="sub_text">
              A space crafted for deep conversations, collaborations,
              interviews, pitches, team huddles, and anything that requires
              presence and connection. Sound-controlled and energy-aligned so
              communication flows without interruption.
            </span>
            <span style={{ marginTop: "10px" }}>
              Ideal <span style={{ color: "#C2B58C" }}>For:</span>
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Team syncs
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Strategy conversations
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Sales calls
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Podcast recordings
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Planning discussions
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Mentor/mentee sessions
            </span>
            <span style={{ marginTop: "10px" }}>
              Experience <span style={{ color: "#C2B58C" }}>Promise:</span>
            </span>
            <span className="sub_text">
              Every conversation here moves you forward.
            </span>
          </div>
        </div>
        <div className="calendar_detail-contact-detail-container">
          <ImageCarousel
            images={getMemberBenefitsRealLifeImages(
              MEMBER_BENEFITS_TYPE.COMMUNICATE_SPACE,
            )}
            title="In Real"
            subTitle="Life"
          />
        </div>
        <div className="calendar_detail-contact-detail-container">
          <div className="footer-container">
            <div className="title">Contact Details</div>
            <div className="sub-container">
              <img src={appTextIcon} alt="sabe-text-logo" />
              <img
                src={whatsappIcon}
                alt="whatsapp-logo"
                onClick={openWhatsappChannel}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
        <ExpandableView title="Terms &" subTitle="Conditions">
          <div className="calendar-detail-expanded-container">
            <div className="divider"></div>
            <div className="sub-container">
              <div className="sub-title">
                {getTermaAndConditionsText(CALENDAR_RESERVATION_TYPE.MEETING_ROOMS)}
              </div>
            </div>
          </div>
        </ExpandableView>
        <button
          className="calendar_detail-reserve-btn"
          onClick={handleReserveClick}
        >
          Reserve Now
        </button>
      </div>
    </div>
  );
};

export default CommunicateSpaceDetailScreen;
